import { Certificate } from '@revenuemarket/bank';
import { Button, Colors, Flex, Text } from '@revenuemarket/cds';
import { formatCompanyTaxNumber } from '@revenuemarket/utils';

import CommonModal from '../CommonModal';

interface CertificateSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  certificate: Certificate;
}

const CertificateSuccessModal = ({
  isOpen,
  onClose,
  certificate,
}: CertificateSuccessModalProps) => {
  return (
    <CommonModal
      width={400}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      title={
        <Text textStyle="16_600" style={{ color: Colors.gray800 }}>
          공동인증서가 등록됐어요
        </Text>
      }
    >
      <Flex direction="column" gap={8} style={{ width: '100%' }}>
        <Flex
          direction="column"
          gap={2}
          style={{
            backgroundColor: Colors.gray30,
            padding: 12,
            borderRadius: 12,
            width: '100%',
          }}
        >
          <Text
            textStyle="13_500"
            style={{
              color: Colors.gray700,
            }}
          >
            {certificate.certificateOwner}
          </Text>
          <Text textStyle="13_400" style={{ color: Colors.gray600 }}>
            {certificate.certificateAuthority || '금융결제원'} ·{' '}
            {certificate.certificateType || '전자세금용'}
          </Text>
          <Text textStyle="13_400" style={{ color: Colors.gray600 }}>
            만료일 {certificate.certificateExpireDate}
          </Text>
        </Flex>

        {certificate.businessRegNumber && (
          <Text textStyle="14_400" style={{ color: Colors.gray700 }}>
            사업자등록번호: {formatCompanyTaxNumber(certificate.businessRegNumber)}
          </Text>
        )}

        <Flex justify="flex-end" style={{ paddingTop: 8 }}>
          <Button border onClick={onClose} buttonType="weak" style={{ width: 60 }}>
            닫기
          </Button>
        </Flex>
      </Flex>
    </CommonModal>
  );
};

export default CertificateSuccessModal;
